// User profile and legal/agreement API – requires auth

import { apiPost } from '../api-client'

/** Response from POST /users/accept-creator-agreement (profile shape) */
export interface AcceptCreatorAgreementResponse {
  id: string
  email?: string
  displayName?: string
  hasAcceptedCreatorAgreement?: boolean
  creatorAgreementAcceptedAt?: string
  [key: string]: unknown
}

/**
 * Mark the current user as having accepted the Creator Agreement.
 * Call refreshUser() after success so the auth context has the updated flags.
 */
export async function acceptCreatorAgreement(): Promise<AcceptCreatorAgreementResponse> {
  return apiPost<AcceptCreatorAgreementResponse>('/users/accept-creator-agreement', {})
}
